import { AxiosResponse } from 'axios';
import {
  RemoteExecutionServiceImpl,
  RemoteGETCallInputObject,
  RemotePOSTCallInputObject,
  ServerResponse,
} from '../../../remoteExecution/RemoteExecutionServiceImpl';
import {
  CreateWorkTaskTemplateRequestDTO,
  UpdateWorkTaskTemplateRequestDTO,
  WorkTaskTemplateResponseDTO,
} from './WorkTaskTemplateInterfaces';

const remoteCallObject = RemoteExecutionServiceImpl();
const backendApiBasePathLocal: string = process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL ?? '';

const CreateWorkTaskTemplateAPICall = async (
  createWorkTaskTemplateRequest: CreateWorkTaskTemplateRequestDTO
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<CreateWorkTaskTemplateRequestDTO> = {
    apiUrl: `${backendApiBasePathLocal}agency/actions/create-work-task-template`,
    headers: {},
    object: createWorkTaskTemplateRequest,
  };

  const workTaskTemplateResponse: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remotePOSTCallV2<
      ServerResponse<WorkTaskTemplateResponseDTO, Error>,
      CreateWorkTaskTemplateRequestDTO
    >(postCallInput);

  if (workTaskTemplateResponse?.data?.data) {
    return workTaskTemplateResponse.data.data;
  }

  return null;
};

const UpdateWorkTaskTemplateAPICall = async (
  updateWorkTaskTemplateRequest: UpdateWorkTaskTemplateRequestDTO
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<UpdateWorkTaskTemplateRequestDTO> = {
    apiUrl: `${backendApiBasePathLocal}agency/actions/update-work-task-template`,
    headers: {},
    object: updateWorkTaskTemplateRequest,
  };

  const workTaskTemplateResponse: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remotePOSTCallV2<
      ServerResponse<WorkTaskTemplateResponseDTO, Error>,
      UpdateWorkTaskTemplateRequestDTO
    >(postCallInput);

  if (workTaskTemplateResponse?.data?.data) {
    return workTaskTemplateResponse.data.data;
  }

  return null;
};

const GetAllWorkTaskTemplatesForAgency = async (): Promise<WorkTaskTemplateResponseDTO[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}agency/get-work-task-templates`,
    headers: {},
    queryParams: null,
  };

  const workTaskTemplatesResponse: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO[], Error>> =
    await remoteCallObject.remoteGETCallV2<ServerResponse<WorkTaskTemplateResponseDTO[], Error>>(getCallInput);

  if (workTaskTemplatesResponse?.data?.data) {
    return workTaskTemplatesResponse.data.data;
  }

  return null;
};

const GetWorkTaskTemplateByIdAPICall = async (
  templateId: string
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}agency/get-work-task-template`,
    headers: {},
    queryParams: { templateId },
  };

  const workTaskTemplateResponse: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remoteGETCallV2<ServerResponse<WorkTaskTemplateResponseDTO, Error>>(getCallInput);

  if (workTaskTemplateResponse?.data?.data) {
    return workTaskTemplateResponse.data.data;
  }

  return null;
};

export {
  CreateWorkTaskTemplateAPICall,
  UpdateWorkTaskTemplateAPICall,
  GetAllWorkTaskTemplatesForAgency,
  GetWorkTaskTemplateByIdAPICall,
};
